/** @file Writes the open draw of a buildRender pass into the draw table (compare-on-write). */
import { invariant } from '@pose2d/std/invariant';
import { RENDER_LAYOUT, type RenderBuffers } from '../renderBuffers';
import type { BuildState } from './buildState';

const DS = RENDER_LAYOUT.DRAW_STRIDE;

/** Writes `st.draw` at row `st.d` when a draw is open (page ≥ 0), flags topology on change, closes it. */
export function flushDraw(out: RenderBuffers, st: BuildState): void {
  const open = st.draw;
  if ((open[0] ?? -1) < 0) return;
  invariant((st.d + 1) * DS <= out.draws.length, 'buildRender: draw capacity exceeded (size with createRenderBuffers or pass extraDraws)');
  const o = st.d * DS;
  for (let j = 0; j < DS; j++) {
    const value = open[j] ?? 0;
    if (out.draws[o + j] !== value) {
      out.draws[o + j] = value;
      st.changed = true;
      st.topo = true;
    }
  }
  st.d += 1;
  open[0] = -1;
}
